import React, { useEffect, useState } from "react";
import ChartTocDropdown from "../../generic/ChartTocDropdown";
import { VolumeSegmentsOptions } from "../../utlits";
import graphQuery from "../../../../../assets/images/graphQuery.svg";
import rupee_currency from "../../../../../assets/images/rupee_currency.svg";
import NoDataFound from "../../generic/NoDataFound";

export interface IVS_TopSalesProps {
  dbData: any;
}

const VS_TopSales: React.FC<IVS_TopSalesProps> = (props) => {
  const [dropdownValue, setDropdownValue] = React.useState<string | number>(
    VolumeSegmentsOptions[0].value
  );

  const [topSales, setTopSales] = useState<any>([]);
  const [disableMenu, setDisableMenu] = useState<boolean>(false);
  const [showGraphQuery, setShowGraphQuery] = useState<boolean>(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.dbData && props.dbData.topSls) {
      let topSalesSegwise = props.dbData.topSls.filter((topSales: any) => {
        return topSales.seg === dropdownValue;
      });
      if (topSalesSegwise.length > 0) {
        setDisableMenu(false);
        setTopSales(topSalesSegwise[0].vol);
      }
    } else {
      setDisableMenu(true);
      setTopSales([]);
    }
  }, [props.dbData, dropdownValue]);

  useEffect(() => {
    /**
     *if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current?.contains(event.target)) {
        setShowGraphQuery(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="top_leaders_container">
      <div className={disableMenu ? "col_head" : "col_head mb-8"}>
        <div className="col_left_head">
          <h4>Top Sales</h4>
          <img
            className="pointer"
            src={graphQuery}
            alt="graphQuery"
            onClick={() => setShowGraphQuery(true)}
          />
          <div
            className="graphQuery_box"
            id={showGraphQuery ? "show_modal" : "hide_modal"}
          >
            <div className="graphQuery" ref={wrapperRef}>
              <span>
                <p>Day wise Earning data for the specific time frame.</p>
              </span>
              <span>
                <i
                  className="edel-icon-close"
                  onClick={() => setShowGraphQuery(false)}
                ></i>
              </span>
            </div>
          </div>
        </div>
        {!disableMenu && (
          <div className="col_right_head hints_text_bottom">
            <ChartTocDropdown
              selectedValue={dropdownValue}
              dropdownOptions={VolumeSegmentsOptions}
              onSelect={(val: any) => {
                setDropdownValue(val);
              }}
              isSearchable={false}
            />
            <span className="hints_text">All Values in CR.</span>
          </div>
        )}
      </div>
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <table className="top_leaders">
          <thead className="">
            <tr>
              <th>Date</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {topSales &&
              topSales.map((leader: any, i: number) => {
                return (
                  <tr key={i}>
                    <td>
                      <img src={rupee_currency} alt={rupee_currency} />
                      <span className="">{leader.key}</span>
                    </td>
                    <td>
                      <span className="rupee_symbol">₹</span>
                      {leader.val}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default VS_TopSales;
